import type {
  IndicatorProps as ReactSelectIndicatorProps,
  OptionTypeBase,
} from 'react-select';

import { Box, type BoxProps } from '@frontend/components';
import { CloseIcon } from '@frontend/components/src/components/mediaAndIcons/icons/iconSet';

import { useSelectStyles } from '../SelectStylesContext';

export type ClearIndicatorProps<
  OptionType extends OptionTypeBase,
  IsMulti extends boolean,
> = ReactSelectIndicatorProps<OptionType, IsMulti> & {
  innerProps: BoxProps;
};

export const ClearIndicator = <
  OptionType extends OptionTypeBase,
  IsMulti extends boolean,
>({
  innerProps,
}: ClearIndicatorProps<OptionType, IsMulti>) => {
  const { clearIndicator: clearIndicatorStyles } = useSelectStyles();

  const { type, ...restInnerProps } = innerProps;

  return (
    <Box
      as="button"
      {...restInnerProps}
      type="button"
      __css={clearIndicatorStyles}
      tabIndex={-1}
    >
      <CloseIcon boxSize="calc(100% * 2 / 3)" />
    </Box>
  );
};
